import styled from "styled-components";

const Label = styled.label<{alignSelf? : boolean}>`
  font-size: 1.45rem;
  font-family: ${({ theme }) => theme.primaryFont};
  color: ${({ theme }) => theme.palette.common.black};
`;

export default Label;